import i18n from '@launchpad/i18n';
import React from 'react';

import EuUnion from '../../assets/countries/european-union.png';
import USAImage from '../../assets/countries/USA.png';
import GBRImage from '../../assets/countries/GBR.png';

const FXRatesItem = ({ currency, text, source, imageStyle, textStyle }) => {
  let src;

  switch (currency) {
    case 'EUR':
      src = EuUnion;
      break;
    case 'USD':
      src = USAImage;
      break;
    case 'GBP':
      src = GBRImage;
      break;
    default:
      src = GBRImage;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 5,
        zIndex: 2
      }}
    >
      <img
        src={source || src}
        alt="country"
        style={{ width: 40, height: 40, ...imageStyle }}
      />
      <p style={{ fontSize: 16, paddingLeft: 15, ...textStyle }}>
        {i18n.t(text)}
      </p>
    </div>
  );
};

export default FXRatesItem;
